// extracted by mini-css-extract-plugin
export default {"text":"ActionsWhenEditing_text__m+uA7","modalContainer":"ActionsWhenEditing_modalContainer__LziGl"};